// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__wrapper___ycfFN {
  position: fixed;
  bottom: 24px;
  left: 24px;
  z-index: 1050;
  max-width: 360px;
  pointer-events: none;
}
.styles__container___ITdUI {
  background-color: #ffffff;
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  padding: 20px;
  pointer-events: auto;
}
.styles__title___taN_O {
  font-size: 18px;
  margin: 0 0 8px;
}
.styles__message___Ijzaq {
  font-size: 14px;
  line-height: 1.4;
  margin: 0 0 16px;
}
.styles__actions___SZYrs {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}
.styles__button___Yjcia {
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 14px;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}
.styles__deny___ZQ4Jb {
  background-color: transparent;
  border: 1px solid #d1d5db;
  color: #374151;
}
.styles__deny___ZQ4Jb:hover {
  border-color: #9ca3af;
  color: #1f2937;
}
.styles__approve___RekPu {
  background-color: #111827;
  color: #ffffff;
}
.styles__approve___RekPu:hover {
  background-color: #000000;
}
`, "",{"version":3,"sources":["webpack://./src/components/components/CookieConsent/styles.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;AACF;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,aAAA;EACA,oBAAA;AAAF;AAGA;EACE,eAAA;EACA,eAAA;AADF;AAIA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AAFF;AAKA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;AAHF;AAMA;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+EAAA;AAJF;AAOA;EACE,6BAAA;EACA,yBAAA;EACA,cAAA;AALF;AAOE;EACE,qBAAA;EACA,cAAA;AALJ;AASA;EACE,yBAAA;EACA,cAAA;AAPF;AASE;EACE,yBAAA;AAPJ","sourcesContent":[".wrapper {\n  position: fixed;\n  bottom: 24px;\n  left: 24px;\n  z-index: 1050;\n  max-width: 360px;\n  pointer-events: none;\n}\n\n.container {\n  background-color: #ffffff;\n  border-radius: 6px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  padding: 20px;\n  pointer-events: auto;\n}\n\n.title {\n  font-size: 18px;\n  margin: 0 0 8px;\n}\n\n.message {\n  font-size: 14px;\n  line-height: 1.4;\n  margin: 0 0 16px;\n}\n\n.actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.button {\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 8px 14px;\n  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n}\n\n.deny {\n  background-color: transparent;\n  border: 1px solid #d1d5db;\n  color: #374151;\n\n  &:hover {\n    border-color: #9ca3af;\n    color: #1f2937;\n  }\n}\n\n.approve {\n  background-color: #111827;\n  color: #ffffff;\n\n  &:hover {\n    background-color: #000000;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles__wrapper___ycfFN`,
	"container": `styles__container___ITdUI`,
	"title": `styles__title___taN_O`,
	"message": `styles__message___Ijzaq`,
	"actions": `styles__actions___SZYrs`,
	"button": `styles__button___Yjcia`,
	"deny": `styles__deny___ZQ4Jb`,
	"approve": `styles__approve___RekPu`
};
export default ___CSS_LOADER_EXPORT___;
